import { Snackbar, SnackbarContent } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { useParams } from "react-router-dom";
import { DatePicker, LoadingPage, MonthFilter, Nodata, useAuth } from "../sdk";
import DOWTable from "./components/DOWTable.js";
import useDOWAnalysis from "./hooks/useDOWAnalysis.js";
import {
  ARRGraph,
  Body,
  BottomRow,
  Header,
  OccupancyGraph,
  Page,
  RevPARGraph,
  SubHeader,
  TableCard,
  WeeklyBody,
  WeeklyCard,
} from "./Styles";
import { PreciumDisabledPage } from "../sdk/components/PreciumDiabledPage";
import { Label } from "../Dashboard/Styles.js";

export const previousDayDate = () => {
  const date = new Date();
  date.setDate(date.getDate() - 1);
  return date;
};

export default function DOWAnalysis({ setPageHeader }) {
  const { token, currentHotel } = useAuth();
  const { hotelId } = useParams();
  const [networkMsg, setNetworkMsg] = useState();
  const [Loading, setLoading] = useState();
  const [startDate, setStartDate] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  );
  const [endDate, setEndDate] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() - 1);
    return date;
  });

  const [comparitiveStartDate, setComparitiveStartDate] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
  );
  const [comparitiveEndDate, setComparitiveEndDate] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 0),
  );

  useEffect(() => {
    if (!token && !hotelId) {
      return;
    } else {
      window.scrollTo(0, 0);
    }
  }, [token, hotelId]);

  const getIndexAsKey = () => {
    return Math.random();
  };

  const {
    selectedData,
    comparitiveData,
    occupancy,
    arr,
    revpar,
    occupancyOptions,
    arrOptions,
    revenueOptions,
    open,
    handleCloseStatus,
  } = useDOWAnalysis(
    startDate,
    endDate,
    comparitiveStartDate,
    comparitiveEndDate,
    setNetworkMsg,
    setLoading,
  );
  useEffect(() => {
    setPageHeader("Day Of Week Analysis");
    return () => {
      setPageHeader("");
    };
  }, []);
  return currentHotel?.isPreciumEnabled ? (
    <Page>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={open}
        onClose={handleCloseStatus}
      >
        <SnackbarContent
          style={{ backgroundColor: "#CA3433" }}
          message={networkMsg}
        />
      </Snackbar>
      <Body>
        <Header>
          <SubHeader>
            <DatePicker
              inputFormat="dd/MM/yyyy"
              value={startDate}
              onChange={setStartDate}
              maxDate={previousDayDate()}
            />
            <Label
              sx={{
                padding: "0 8px",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              To
            </Label>
            <DatePicker
              inputFormat="dd/MM/yyyy"
              value={endDate}
              onChange={setEndDate}
              minDate={startDate}
              maxDate={previousDayDate()}
            />
            <div style={{ display: "flex", alignItems: "center" }}>
              <p
                style={{
                  color: "#110641",
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  padding: "0px 8px",
                }}
              >
                Compare with
              </p>
            </div>
            <DatePicker
              inputFormat="dd/MM/yyyy"
              value={comparitiveStartDate}
              onChange={setComparitiveStartDate}
              maxDate={previousDayDate()}
            />
            <Label
              sx={{
                padding: "0 8px",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              To
            </Label>
            <DatePicker
              inputFormat="dd/MM/yyyy"
              value={comparitiveEndDate}
              onChange={setComparitiveEndDate}
              minDate={comparitiveStartDate}
              maxDate={previousDayDate()}
            />
          </SubHeader>
        </Header>
        {!Loading ? (
          Object.entries(selectedData).length !== 0 &&
          Object.entries(comparitiveData).length !== 0 ? (
            <BottomRow>
              <WeeklyCard>
                <WeeklyBody>
                  <OccupancyGraph>
                    <Bar
                      data={occupancy}
                      options={occupancyOptions}
                      datasetKeyProvider={getIndexAsKey}
                    />
                  </OccupancyGraph>
                  <ARRGraph>
                    <Bar
                      data={arr}
                      options={arrOptions}
                      datasetKeyProvider={getIndexAsKey}
                    />
                  </ARRGraph>
                  <RevPARGraph>
                    <Bar
                      data={revpar}
                      options={revenueOptions}
                      datasetKeyProvider={getIndexAsKey}
                    />
                  </RevPARGraph>
                </WeeklyBody>
              </WeeklyCard>
              <TableCard>
                <DOWTable
                  startDate={startDate}
                  comparitiveStartDate={comparitiveStartDate}
                  selectedData={selectedData}
                  comparitiveData={comparitiveData}
                />
              </TableCard>
            </BottomRow>
          ) : (
            <Nodata />
          )
        ) : (
          <LoadingPage />
        )}
      </Body>
    </Page>
  ) : (
    <PreciumDisabledPage />
  );
}
